import { Typography } from "@mui/material";
import { format } from "date-fns";
import { StyledDependenciaSeleccionadaLabel } from "../../styled/ExamenesPeriodicos";

const DependenciaSeleccionadaLabel = ({ data }) => {
  const noData = !Object.keys(data).length;
  const noDataText = "No hay datos";
  return (
    <StyledDependenciaSeleccionadaLabel.Container noData={noData}>
      {noData ? (
        <StyledDependenciaSeleccionadaLabel.CenterText variant="body2">
          No hay datos disponibles
        </StyledDependenciaSeleccionadaLabel.CenterText>
      ) : (
        <>
          <StyledDependenciaSeleccionadaLabel.LeftText>
            {data.nombre ? (
              <>
                <Typography variant="body2">
                  <strong>{data?.nombre?.split(":")[1]}</strong>
                </Typography>
                <Typography variant="body2" style={{ marginLeft: 20 }}>
                  <strong>{data?.nombre?.split("-")[0]}</strong>
                </Typography>
              </>
            ) : (
              <Typography>{noDataText}</Typography>
            )}
          </StyledDependenciaSeleccionadaLabel.LeftText>
          <StyledDependenciaSeleccionadaLabel.CenterText variant="body2">
            {data.domicilio ? data?.domicilio : noDataText}
          </StyledDependenciaSeleccionadaLabel.CenterText>
          <StyledDependenciaSeleccionadaLabel.RightText variant="body2">
            <strong>
              Periodo:{" "}
              {data.fechaDesde
                ? format(data?.fechaDesde, "dd/MM/yyyy")
                : noDataText}{" "}
              al{" "}
              {data.fechaHasta
                ? format(data?.fechaHasta, "dd/MM/yyyy")
                : noDataText}
            </strong>
          </StyledDependenciaSeleccionadaLabel.RightText>
        </>
      )}
    </StyledDependenciaSeleccionadaLabel.Container>
  );
};

export default DependenciaSeleccionadaLabel;
